class UrlsService{
    private _startDate: string;
    private _endDate: string;
    private _comparison:number

    public set endDate(value: string) {
        this._endDate = value;
    }

    public set startDate(value: string) {
        this._startDate = value;
    }
    public set comparison(value: number) {
        this._comparison = value;
    }

    public login(): string {
        return "/login"
    }

    public app(): string {
        return "/"
    }

    public home(): string{
        return "/home"
    }
    public alerts(): string {
        return "/alerts"
    }

    public editAlert(id: string = ":id"): string {
        return  `${this.alerts()}/${id}`
    }
    public createAlert(): string {
        return `${this.alerts()}/create`
    }

    public groups(): string {
        return "/groups"
    }

    public editGroup(id: string = ":id"): string {
        return `${this.groups()}/${id}`
    }

    public createGroup(): string {
        return `${this.groups()}/create`
    }

    public adServers(): string {
        return "/ad-servers"
    }

    public editAdServer(id: string = ":id"): string {
        return `${this.adServers()}/${id}`
    }

    public createAdServer(): string {
        return `${this.adServers()}/add`
    }
    public adServerOverview(id:string=":id",shouldAddDates?:boolean):string{
        return `${this.adServers()}/overview/${id}/${this._getDatesQueryParams(shouldAddDates)}`
    }

    public partnerOverview(id:string=":id",shouldAddDates?:boolean):string{
        return `${this.partners()}/overview/${id}/${this._getDatesQueryParams(shouldAddDates)}`
    }


    public dataPoints(): string {
        return "/data-points"
    }

    public editDataPoint(id: string = ":id"): string {
        return `${this.dataPoints()}/${id}`
    }

    public dataPointOverview(id: string = ":id", shouldAddDates?: boolean): string{
        return `${this.dataPoints()}/overview/${id}${this._getDatesQueryParams(shouldAddDates)}`
    }

    public createDataPoint(): string {
        return `${this.dataPoints()}/add`
    }

    public partners(): string {
        return "/partners"
    }

    public partnersAssign(): string{
        return `${this.partners()}/assign`
    }

    public partnersAssignDemand(): string{
        return `${this.partners()}/assign`
    }

    public partnersAssignSupply(): string{
        return `${this.partners()}/assign/supply`
    }


    public partnersDemand(): string{
        return `${this.partners()}/demand`
    }

    public partnersOverviewDemand(): string{
        return `${this.partners()}/demand/overview`
    }

    public partnersOverviewSupply(): string{
        return `${this.partners()}/supply/overview`
    }

    public partnersSupply(): string{
        return `${this.partners()}/supply`
    }

    public partnersAliasSupply(): string{
        return `${this.partners()}/alias/supply`
    }

    public partnersAliasDemand(): string{
        return `${this.partners()}/alias/demand`
    }

    public editPartner(id: string = ":id"): string {
        return `${this.partners()}/${id}`
    }

    public createPartner(): string {
        return `${this.partners()}/add`
    }

    public createAlias(): string {
        return `${this.partners()}/alias/add`
    }

    public editAlias(id: string= ':id'): string{
        return `${this.partners()}/alias/${id}`
    }

    public publisherDataPoints(shouldAddDates?: boolean): string {
        return `/publisher-logins${this._getDatesQueryParams(shouldAddDates)}`
    }

    public publisherDataPoint(id: string = ":id", shouldAddDates?: boolean): string {
        return `${this.publisherDataPoints()}/data-points/${id}${this._getDatesQueryParams(shouldAddDates)}`
    }

    public publisherTags(): string {
        return `/publisher-tags`
    }

    public publisherTag(id: string = ":id", shouldAddDates?: boolean): string {
        return `${this.publisherTags()}/${id}${this._getDatesQueryParams(shouldAddDates)}`
    }

    public demandTags(): string {
        return '/demand-tags'
    }

    public demandTag(id: string = ":id", shouldAddDates?: boolean): string {
        return `${this.demandTags()}/${id}${this._getDatesQueryParams(shouldAddDates)}`
    }

    public adServerTags(): string {
        return '/ad-server-tags'
    }

    public adServerTag(id: string = ":id", shouldAddDates?: boolean): string {
        return `${this.adServerTags()}/${id}${this._getDatesQueryParams(shouldAddDates)}`
    }

    public priceRules(): string {
        return '/pricerules'
    }

    public editPriceRule(id: string = ":id"): string {
        return `${this.priceRules()}/${id}`
    }

    public createPriceRule(): string {
        return `${this.priceRules()}/add`
    }

    public reports(): string {
        return '/reports'
    }

    private _getDatesQueryParams(shouldAddDates): string {
        if (!shouldAddDates) {
            return "";
        }

        if (!(this._startDate && this._endDate)) {
            return ""
        }
        return `?startDate=${this._startDate}&endDate=${this._endDate}&comparison=${this._comparison}`
    }



}

const urlService = new UrlsService();

export {urlService}